/**
 * 格式化金额 逢三位转逗号,保留两位小数，支持负数
 */
export function moneyFmt(num) {
    if(!num){
      return '0.00';
  }
  var num = num + '';
  var d = '';
  if (num.slice(0, 1) == '-'){
    d = num.slice(0, 1);
    num = num.slice(1);
  }
  var len = num.length;
  var index = num.indexOf('.');
  if (index == -1) {
    num = num + '.00';
  } else if ((index + 2) == len) {
    num = num + '0';
  }
  var index = num.indexOf('.'); // 字符出现的位置
  var num2 = num.slice(-3);
  num = num.slice(0,index)
  var result = '';
  while (num.length > 3) {
    result = ',' + num.slice(-3) + result;
    num = num.slice(0, num.length - 3);
  }
  if (num) {
    result = num + result;
  }
  return d + (result + num2);
}

export function moneyFormat(money) {
    money = money + ''
    // 是否是负数
    var type = money.lastIndexOf("-") != -1;
    var flag = type ? money.slice(1).length >= 7 : money.length >= 7
    if (flag) {
        var moneyObj = null;
        // {value: '152.87', unit: '万'}
        if (type) {
            moneyObj = numberFormat(money.slice(1));
        } else {
            moneyObj = numberFormat(money);
        }
        var t = moneyObj.value + moneyObj.unit
        if (type) {
            t = "-" + t
        }
        return t;
    }
    return money;
}
/**
 * 超过万就展示单位
 * 
 * @param {*} value 
 * return {value: '1521.45', unit: '万'}
 */
export function numberFormat(value) {
    var param = {};
    var k = 10000,
        sizes = ['', '万', '亿', '万亿'],
        i;
    if (value < k) {
        param.value = Number(value).toFixed(2)
        param.unit = ''
    } else {
        i = Math.floor(Math.log(value) / Math.log(k));
        param.value = ((value / Math.pow(k, i))).toFixed(2);
        param.unit = sizes[i];
    }
    return param;
}
